import { WinnersPageService } from './../core/services/winners-page.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-winnerspage',
  templateUrl: './winnerspage.component.html',
  styleUrls: ['./winnerspage.component.scss']
})
export class WinnerspageComponent implements OnInit {
  periodList:any;
  selectedPeriod:any;
  monthlyPrizeGiveawayList:any=[];
  quaterlyPrizeGiveAwayList:any=[];
  constructor(private winnerService: WinnersPageService) { }

  ngOnInit() {
    this.getperiodList();
  }

  participateLink(){
    window.open('https://sellerrewards.cisco.com/home/seller/challenges');
  }
  getperiodList(){
    this.winnerService.getDropdownOptions().subscribe((data)=>{
 
      this.periodList=data;
      this.selectedPeriod=data[0];
  
    })
  }
  onChangePeriodList(data){
    this.monthlyPrizeGiveawayList=[];
    this.quaterlyPrizeGiveAwayList=[];
    var param='?fiscalYear='+data.fiscalYear+'&fiscalQuarter='+data.fiscalQuarter;
    this.winnerService.getquarterlyWinnersData(param).subscribe((data)=>{
      
      const Monthlysearch = '$500 Token Voucher Monthly Prize Giveaway';
      const QuarterlySearch="$1,000 Token Voucher Quarterly Prize Giveaway"
      var newList = data.content.filter(element => {
      
                if(element['rewardName'] == Monthlysearch) {
                    this.monthlyPrizeGiveawayList.push(element);
        }else if(element['rewardName'] == QuarterlySearch){
          this.quaterlyPrizeGiveAwayList.push(element)
        }
    });
 
    })
    
   
  }
}
